export default {
	title: "Livello Vip",
	current: "Livello VIP Attuale",
	status: {
		btn: ["Attivato", "Iscriviti ora"]
	}
};
